import { Suspense, lazy } from "react";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import About from "./components/About";
import { ExperiencePage } from "./components/ExperiencePage"; // Advanced experience view
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Hobbies from "./components/Hobbies";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LoadingScreen from "./components/LoadingScreen";
// Lazy loaded heavy Chatbot (animations, speech)
const Chatbot = lazy(() => import("./components/Chatbot"));
import { ChatbotProvider } from "./context/ChatbotContext";
import { ConfigProvider } from "./context/ConfigContext";
import { useConfig } from "./context/useConfig";

function AppContent() {
  const { config, isBackendAvailable } = useConfig();

  // Only show loading if we don't have ANY config yet (should never happen with static config)
  if (!config) {
    return <LoadingScreen message="Loading content..." />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HomePage />
        <About />
        {/* Unified Experience section (replaces legacy <Experience />) */}
        <ExperiencePage />
        <Projects />
        <Skills />
        <Hobbies />
        <Contact />
      </main>
      <Footer />
      {isBackendAvailable && (
        <Suspense fallback={<div className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-gray-300 animate-pulse" aria-label="Loading chat" />}>
          <Chatbot />
        </Suspense>
      )}
    </div>
  );
}

function App() {
  return (
    <ConfigProvider>
      <ChatbotProvider>
        <AppContent />
      </ChatbotProvider>
    </ConfigProvider>
  );
}

export default App;
